import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getBusinessUserList = async (businessUserid) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/Chat/BusinessUserConversationList`, {
            params: {
                businessUserid,
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching conversation list:", error);
        throw error;
    }
};
